import { usePageTitle } from '@athena/ui'
import type { ReactNode } from 'react'

/**
 * A whole page that is only a message — the app could not reach the server,
 * the address matches nothing — given the same identity every other page has:
 * a `main` landmark, one `h1` that a navigation can land on, and a document
 * title that says the same.
 */
export function PageMessage({ title, children }: { title: string; children?: ReactNode }) {
  usePageTitle(title)

  return (
    <main className="flex flex-col items-start gap-4 p-8">
      <h1 tabIndex={-1} className="text-h2 font-bold text-text outline-none">
        {title}
      </h1>
      {children}
    </main>
  )
}
